module.exports = __webpack_public_path__ + "static/saemi.park.changwon.lee-d90c51ded23b5f0618a96cb2e8d12980.png";